'use client'

import { useContext, useState } from 'react'
import OEmbed from '@/components/embeds/OEmbed/OEmbed'
import { ConsentContext } from '@/context/ConsentContext'
import { UserConsents } from '@/types/consent'
import styles from './EmbedSocial.module.scss'
import NoConsent from './NoConsent'
import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'

// toDo: löschen?!

const EmbedSocial = ({
  type,
  url,
  youtubeId,
  cookies,
}: {
  type: string
  url?: string
  youtubeId?: string
  cookies: RequestCookie[]
}) => {
  interface TypeToVendorMap {
    [key: string]: keyof UserConsents
  }

  const typeToVendorMap: TypeToVendorMap = {
    instagram: 'instagram',
    instagram_2: 'instagram',
    facebookpost: 'facebook',
    facebookvideo: 'facebook',
    tiktok: 'tiktok',
    twitter: 'x',
    youtube: 'youtube',
  }

  const consentContext = useContext(ConsentContext)

  const [forceShowEmbed, setForceShowEmbed] = useState<boolean>(false)

  let embedUrl = url
  if (type === 'instagram_2') {
    embedUrl = embedUrl + '&hidecaption=true'
  }
  if (type === 'youtube') {
    embedUrl = 'https://www.youtube.com/watch?v=' + youtubeId
  }

  if (consentContext.consentReady) {
    if ((consentContext.userConsents && consentContext.userConsents[typeToVendorMap[type]]) || forceShowEmbed) {
      if (embedUrl) {
        if (type === 'youtube') {
          return (
            <div className={styles.youtubewrapper}>
              <OEmbed url={embedUrl} />
            </div>
          )
        } else {
          return <OEmbed url={embedUrl} />
        }
      }
    } else {
      return (
        <NoConsent
          type={type}
          purMode={consentContext.status === 'purMode' ? true : false}
          setForceShowEmbed={setForceShowEmbed}
          cookies={cookies}
        />
      )
    }
  }
  return <></>
}

export default EmbedSocial
